import { Injectable } from '@angular/core';

import { ParticipantMarketType } from '@cds/betting-offer';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { WinGameFixture, WinGameParticipant } from '@frontend/sports/racing/feature/models';
import { sortBy } from 'lodash-es';

@Injectable()
export class ResultedDividentsCalculatorService {
    constructor(public sitecore: Sitecore) {}

    getDividends(fixture: WinGameFixture): Array<{ name: string; value: string; available: boolean; result: string }> {
        const markets = [
            {
                name: this.sitecore.horseRacing.markets.Forecast,
                type: ParticipantMarketType.Forecast.toLowerCase(),
                available: false,
                value: '',
                result: '',
            },
            {
                name: this.sitecore.horseRacing.markets.Tricast,
                type: ParticipantMarketType.Tricast.toLowerCase(),
                available: false,
                value: '',
                result: '',
            },
        ];
        markets.forEach((dividend) => {
            const fixtureMarket = fixture.addons.participantDividend && fixture.addons.participantDividend[dividend.type];
            dividend.available = !!fixtureMarket;

            if (fixtureMarket) {
                dividend.value = fixtureMarket.map((_) => _.value).join(', ');
                if (fixtureMarket.length) {
                    dividend.result = fixtureMarket
                        .map((val) => this.getResultedValue(fixture.participants, val.orderedFixtureParticipantIds, fixture.sport.id))
                        .join(', ');
                }
            }
        });

        return markets;
    }

    private getResultedValue(participants: WinGameParticipant[], participantIds: number[], sportId: SportConstant = SportConstant.Horses): string {
        const filteredData = participants.filter((participant) => participantIds.includes(participant.id));
        const sortedData = sortBy(filteredData, (data) => participantIds.indexOf(data.id));

        if (sportId === SportConstant.Greyhounds) {
            return sortedData.map((p) => p.participantId).join('-');
        } else {
            return sortedData.map((p) => p.properties!.raceCardNumber).join('-');
        }
    }
}
